const ButtonLoader = () => {
  return (
    <span className="animate-spin inline-block size-4 border-[3px] border-current border-t-transparent text-white rounded-full me-1"></span>
  );
};

export default ButtonLoader;
